import { useLocation } from 'react-router';

import { Box } from '#/components/Box/Box';
import { CareersNotFoundContent } from '#/components/CareersNotFoundContent/CareersNotFoundContent';
import { NotFoundContent } from '#/components/NotFoundContent/NotFoundContent';
import { useTrackPageView } from '#/hooks/useTrackPageView';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { gutterWidth, maxWidth } from '#/theme/theme';

type Props = {
  searchText?: string;
  searchUrl?: string;
};

export function NotFoundPage({ searchText, searchUrl }: Props) {
  const { i18n } = useI18n();
  const location = useLocation();
  const isCareers = location.pathname.startsWith('/en/careers/');

  useTrackPageView(isCareers ? 'Career Advice 404 Page' : '404 Page');

  return (
    <RouteModule
      title={
        /* TRANSLATORS: 404 page title */
        i18n('Page Not Found')
      }
    >
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        px={[gutterWidth / 2, null, null, gutterWidth]}
        py={[gutterWidth / 2, null, null, gutterWidth, '28px']}
      >
        {isCareers ? (
          <CareersNotFoundContent />
        ) : (
          <NotFoundContent searchText={searchText} searchUrl={searchUrl} />
        )}
      </Box>
    </RouteModule>
  );
}
